import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import img1 from "../assets/img/bandeau.jpg";

export const ContesMeditatifs = () => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Supprimez l'écran de chargement lorsque la page est entièrement chargée
    const handleLoad = () => {
      setLoading(false);
    };

    window.addEventListener('load', handleLoad);

    // Nettoyage de l'écouteur d'événements lors du démontage du composant
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);
  return (
    <>

      {loading && (

        <div className="video-gallery">
          <h2 style={{ marginTop: '20px' }}>Retrouvez mes contes méditatifs</h2>
          <div className="video-container">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/Z2tOcUUzqEc?si=SxjwqOWvIlVj_qUH"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/Kdc2CxlFLgs?si=msY-n32eRkPYwEr4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/p_8_qrnZaYA?si=axBc8pbEgLn9Dx_O"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>)}
    </>
  );
}

